/**
 * Å se stedet i bevegelse, før man bestemmer seg for å reise dit.
 *
 * Hvert stopp har ett kuratert bilde. Et bilde er valgt fra sin beste kant på
 * sin beste dag, og det er nettopp derfor det ikke svarer på spørsmålet
 * «hvordan er det egentlig der» — hvor bratt er stien, hvor mye folk er det,
 * hvor lang er den veien. Video svarer på det.
 *
 * Dette er et *søk*, ikke en anbefaling, og det er et bevisst valg framfor de
 * to alternativene:
 *
 *   YouTube Data API gir kuraterbare treff, men koster en nøkkel på et
 *   Google-prosjekt med fakturering, og et søk koster 100 av 10 000 enheter
 *   per døgn. Det er hundre søk om dagen for hele appen — mindre enn
 *   språkmodellen, som allerede er den knappeste ressursen vi har.
 *
 *   Innebygd avspiller setter sporingsinformasjonskapsler før noen har trykket
 *   play, og krever samtykke for noe som er pynt. En lenke ut gjør ikke det:
 *   brukeren velger selv å gå til YouTube.
 *
 * Derfor står det «YouTube-søk» ved siden av lenka i grensesnittet. Vi har
 * ikke sett videoene, og da skal vi ikke se ut som om vi har det.
 */

/**
 * Landsnavnet legges til fordi stedsnavn alene er tvetydige.
 *
 * «Bergen» finnes i Tyskland og Nederland, «Voss» er et vannmerke før det er
 * en bygd, og «Finse» uten kontekst gir like gjerne et etternavn. Ett ord
 * fjerner nesten all støyen — og på brukerens eget språk gir det i tillegg
 * treff laget av folk som har reist samme vei og filmet på samme språk.
 */
export function videoSearchUrl(name: string, country?: string): string {
  const place = name.trim();
  /*
   * «Nord-Norge» skal ikke bli «Nord-Norge Norge». Enkel tekstsjekk framfor
   * regulæruttrykk, siden navnene inneholder bindestreker og parenteser som
   * ville måttet unnslippes.
   */
  const needsCountry =
    country !== undefined && !place.toLowerCase().includes(country.toLowerCase());

  const query = [place, needsCountry ? country : undefined].filter(Boolean).join(" ");

  return `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}`;
}
